<template>
  <div class="layout-wrapper">
    <header id="page-topbar">
      <slot name="header-left">
        <el-button type="info" class="n-btn" @click="$router.go(-1)">Quay lại</el-button>
      </slot>

      <div class="title">
        <slot name="title">
          <p>Tạo đơn trả hàng</p>
        </slot>
      </div>

      <slot name="header-right">
        <el-button type="primary" class="n-btn" @click="$emit('submit')">Xác nhận đơn</el-button>
      </slot>
    </header>
  </div>
</template>

<script>
export default {
  name: "Head"
};
</script>

<style lang="scss" scoped>
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>